/**
 * Feature Flags Configuration
 *
 * Controls which features are enabled in different environments.
 * Use environment variables to toggle features on/off.
 */

/**
 * Check if Sponsorships module is enabled
 *
 * Controlled by NEXT_PUBLIC_ENABLE_SPONSORSHIPS environment variable
 * - Set to 'true' to enable (development, preview)
 * - Set to 'false' or leave unset to disable (production)
 */
export function isSponsorshipsEnabled(): boolean {
  // Check environment variable (explicit enable/disable)
  if (process.env.NEXT_PUBLIC_ENABLE_SPONSORSHIPS === 'true') {
    return true;
  }
  if (process.env.NEXT_PUBLIC_ENABLE_SPONSORSHIPS === 'false') {
    return false;
  }

  // Enable in development by default
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  // Enable on preview (Vercel staging)
  if (process.env.VERCEL_ENV === 'preview' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview') {
    return true;
  }

  // Default to enabled in production (Sponsorships module is now live)
  return true;
}

/**
 * Get all feature flags
 */
export function getFeatureFlags() {
  return {
    sponsorships: isSponsorshipsEnabled(),
  };
}
